<template>
    <div class="form-field margin-right-10 select-project">
        <drop-down v-if="projects.length > 1"
                   :items="projects"
                   :dataField="'Id'"
                   :textField="'Name'"
                   :selectedValue="projectId"
                   :cssClass="'margin-right-10'"
                   @change="onProjectChange($event)"></drop-down>

    </div>
</template>

<script>
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import claimUtils from '../helpers/claimUtils'

    let backendApi = new BackendApi();

    export default {
        name: "project-select",

        props: ['user'],

        mixins: [projectMixin],

        data(){
            return{
                projects: [],
            }
        },

        methods:{
            onProjectChange(item) {
                localStorage.setItem('selectedProjectId', item.Id);
                this.projectId = item.Id;

                this.$emit('onChange', item);
                //this.$emit('project-changed', item);
            }
        },

        mounted() {
            let vm = this;
            let selectedProjectId = localStorage.getItem('selectedProjectId');

            backendApi.projectList(0, 100)
                .then(function (resp) {
                    if(resp.data && resp.data.length) {
                        if (resp.data.length && selectedProjectId== null) {
                            localStorage.setItem('selectedProjectId', resp.data[0].Id);
                        }
                        if(vm.user.MainRole === 'administrators'){
                            vm.projects = resp.data;
                        }
                        else{
                            let routeName = vm.$route.name;
                            for(let project of resp.data){
                                let dynamicRole = vm.user.DynamicRoles.find(x => x.ProjectId === project.Id);
                                if(dynamicRole != null){
                                    let pageClaim = claimUtils.getClaimByRouteName(routeName);
                                    if(pageClaim === undefined || !dynamicRole.Claims.find(x => x.ClaimId === pageClaim)){
                                        continue;
                                    }
                                }
                                vm.projects.push(project);
                            }
                        }
                    }
                });


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/ProjectSelect.vue